"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CaretDownIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "16",
  height: "10",
  viewBox: "0 0 16 10",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-309.000000, -241.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(311.000000, 243.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(6.000000, 3.000000) rotate(-180.000000) translate(-6.000000, -3.000000) translate(-1.500000, -1.500000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(7.500000, 4.500000) rotate(-180.000000) translate(-7.500000, -4.500000) ",
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                transform: "translate(7.500000, 4.500000) rotate(180.000000) translate(-7.500000, -4.500000) ",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M6.50940378,0.424878542 C7.05398222,-0.104948555 7.89876976,-0.138330803 8.48116454,0.31956495 L8.62097114,0.444270856 L14.5655684,6.44427086 C15.1486315,7.03276802 15.1442263,7.98250528 14.5557291,8.56556838 C14.012501,9.10378048 13.1614706,9.14142789 12.5751623,8.68116615 L12.4344316,8.55572914 L7.536,3.6105 L2.54599897,8.46649774 C1.99790065,8.99974939 1.14656322,9.02965895 0.564463153,8.56408639 L0.424878542,8.43737526 C-0.108373102,7.88927693 -0.138282662,7.03793951 0.327289893,6.45583944 L0.454001027,6.31625483 L6.50940378,0.424878542 Z"
                })
              })
            })
          })
        })
      })
    })
  })]
});

CaretDownIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = CaretDownIcon;
exports.default = _default;